<div class="container_loader" *ngIf="loading">
    <div class="loader"></div>
</div>

<!-- <div class="modal noCard" > -->
<div class="modal noCard" *ngIf="this.cards.cards.length == 0 && !loading">
    <div class="modal__container">
        <div class="modal__header">
            <div class="modal__title">Debes afiliar una tarjeta para continuar</div>
        </div>
        <div class="modal__body">
            <div class="modal__form" *ngIf="this.modalError">
                <p class="alert red">{{this.modalError}}</p>
            </div>
            <form class="modal__form" [formGroup]="formNewCard">
                <div class="modal__form">
                    <label for="">Número</label>
                    <input (keypress)="onlyNumber($event)" maxlength="20" type="text" formControlName="numTar">
                </div>
                <div class="modal__form">
                    <label for="">Nombre</label>
                    <input maxlength="20" type="text" maxlength="25" formControlName="nombre">
                </div>

            </form>
        </div>
        <div class="modal__footer">
            <button class="btn" (click)="addNewCard()">Afiliar</button>
            <button class="btn btn-cancelar" (click)="closeSession()">Cerrar sesion</button>
        </div>
    </div>
</div>
<div class="modal" *ngIf="confirmDel">
    <div class="modal__container">
        <div class="modal__header">
            <div class="modal__title">¿deseas desafiliar el medios de acceso?</div>
        </div>
        <div class="modal__body">
            <div class="modal__form">
                <p class="alert ">vas a desafiliar el siguiente medios de acceso: {{this.numTarjeta}}</p>
            </div>
        </div>
        <div class="modal__body" *ngIf="modalError">
            <div class="modal__form">
                <p class="alert red">{{modalError}}</p>
            </div>
        </div>
        <div class="modal__footer">
            <div *ngIf="loaderBtn" class="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <button *ngIf="!loaderBtn" class="btn danger" (click)="delete()">Desafiliar</button>
            <button class="btn btn-cancelar" (click)="closeModal()">Cancelar</button>
        </div>
    </div>
</div>
<div class="resumen__side">
    <div class="resumen__side__header">
        <h1>Bienvenido {{this.nombre}}</h1>
    </div>

    <div class="resumen__side__tarjetas">
        <div class="sliderCards">
            <ng-container *ngIf="loading">
                <div class="tarjeta loading">

                    <div class="tarjeta__content">
                        <div class="tarjeta__content__top">
                            <div class="tarjeta__content__top__title">
                                <h3>Obteniendo medios de acceso</h3>
                                <h3>por favor espere</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngFor="let data of this.tarjetasOrdenadas(); let i = index; trackBy: trackById">

                <div class="tarjeta" (click)="dataResumen(i)"
                    [className]="this.cardSelected == data.numTarjeta ?'tarjeta tarjeta__active' : 'tarjeta' ">
                    <div class="tarjeta__content">
                        <div class="tarjeta__content__top">
                            <img src="assets/icons/logoTarjeta.svg" alt="">
                            <div class="tarjeta__content__top__title">
                                <h3>{{data.nombreTarjeta}}</h3>
                                <p>{{data.numTarjeta}}</p>

                            </div>
                        </div>
                        <div class="tarjeta__content__bottom">
                            <div>
                                <p>Saldo disponible</p>
                                <h3>
                                    <strong *ngIf="data.saldo else saldoNull">$ {{data.saldo}}</strong>
                                    <ng-template #saldoNull>
                                        <strong>Saldo no disponible</strong>
                                    </ng-template>
                                </h3>
                            </div>
                        </div>
                        <button *ngIf="this.cardSelected == data.numTarjeta" class="btn-del"
                            (click)="openModalDel(data.numTarjeta)">Eliminar</button>
                    </div>


                </div>

            </ng-container>
        </div>
        <p *ngIf="this.cards.cards.length > 1" class="status">Usted tiene {{this.cards.cards.length}} medios de accesos
            afiliados
        </p>
        <p *ngIf="this.cards.cards.length === 1" class="status">Usted tiene {{this.cards.cards.length}} medio de acceso
            afiliado
        </p>
    </div>

    <div class="resumen__side__footer">
        <div class="btn-group-danger">
            <button class="btn" title="Tengo problemas con mi tarjeta" (click)="sendSolici()">Tengo problemas
                con mi medio de acceso</button>
        </div>
    </div>

</div>